import { DropdownItem } from "src/Interfaces/dropdownInterfaces";
import { Report } from "../Interfaces/TableInterfaces";
import { Packet } from "../Interfaces/commonDtos";
import {
  IFreezeTablesSearchParams,
  IFreezeReleaseCalculationsTableReport,
  IFreezeReleaseRequestsTableReport,
  IFreezeCalculationsTableReport,
  IFreezeRequestsTableReport,
} from "../Interfaces/freeze";
import {
  getTable,
  patchRequest,
  postDownloadExcel,
  postRequest,
} from "./requestTemplates";
import { AxiosRequestConfig } from "axios";

export const getFreezeReleaseCalculationsTable = (
  searchParam: IFreezeTablesSearchParams,
  offset: number | null,
  pageSize: number | null,
  sortingType: string,
  additional?: DropdownItem,
  axiosOptions?: AxiosRequestConfig
): Promise<Report<IFreezeReleaseCalculationsTableReport>> =>
  getTable<IFreezeTablesSearchParams, IFreezeReleaseCalculationsTableReport>(
    "/v1/Freeze/ReleaseCals",
    searchParam,
    offset,
    pageSize,
    sortingType,
    additional,
    axiosOptions
  );

export const getFreezeReleaseRequestsTable = (
  searchParam: IFreezeTablesSearchParams,
  offset: number | null,
  pageSize: number | null,
  sortingType: string,
  additional?: DropdownItem,
  axiosOptions?: AxiosRequestConfig
): Promise<Report<IFreezeReleaseRequestsTableReport>> =>
  getTable<IFreezeTablesSearchParams, IFreezeReleaseRequestsTableReport>(
    "/v1/Freeze/ReleaseReqs",
    searchParam,
    offset,
    pageSize,
    sortingType,
    additional,
    axiosOptions
  );

export const getFreezeCalculationsTable = (
  searchParam: IFreezeTablesSearchParams,
  offset: number | null,
  pageSize: number | null,
  sortingType: string,
  additional?: DropdownItem,
  axiosOptions?: AxiosRequestConfig
): Promise<Report<IFreezeCalculationsTableReport>> =>
  getTable<IFreezeTablesSearchParams, IFreezeCalculationsTableReport>(
    "/v1/Freeze/FreezeCals",
    searchParam,
    offset,
    pageSize,
    sortingType,
    additional,
    axiosOptions
  );

export const getFreezeRequestsTable = (
  searchParam: IFreezeTablesSearchParams,
  offset: number | null,
  pageSize: number | null,
  sortingType: string,
  additional?: DropdownItem,
  axiosOptions?: AxiosRequestConfig
): Promise<Report<IFreezeRequestsTableReport>> =>
  getTable<IFreezeTablesSearchParams, IFreezeRequestsTableReport>(
    "/v1/Freeze/FreezeReqs",
    searchParam,
    offset,
    pageSize,
    sortingType,
    additional,
    axiosOptions
  );

export const getFreezeReleaseCalculationsExcel = (
  searchParam: IFreezeTablesSearchParams
) => {
  const rand = Math.random();
  return postDownloadExcel(`/v1/Freeze/ReleaseCalsExcel?${rand}`, searchParam);
};

export const getFreezeCalculationsExcel = (
  searchParam: IFreezeTablesSearchParams
) => {
  const rand = Math.random();
  return postDownloadExcel(`/v1/Freeze/FreezeCalsExcel?${rand}`, searchParam);
};

export const getFreezeReleaseRequestsExcel = (
  searchParam: IFreezeTablesSearchParams
) => {
  const rand = Math.random();
  return postDownloadExcel(`v1/Freeze/ReleaseReqsExcel?${rand}`, searchParam);
};

export const getFreezeRequestsExcel = (
  searchParam: IFreezeTablesSearchParams
) => {
  const rand = Math.random();
  return postDownloadExcel(`/v1/Freeze/FreezeReqsExcel?${rand}`, searchParam);
};

export const addBulkReleaseRequest = (
  requestIds: number[]
): Promise<Packet<boolean>> =>
  postRequest("/v1/Freeze/AddReleaseBulkReqs", { requestIds });

export const addReleaseRequest = (
  requestId: number
): Promise<Packet<boolean>> =>
  postRequest("/v1/Freeze/AddReleaseReqs", { requestId });

export const editReleaseCalc = (body: {
  requestId: number;
  amount: number;
}): Promise<Packet<boolean>> =>
  patchRequest("/v1/Freeze/EditReleaseCalc", body);

export const addBulkFreezeRequest = (
  requestIds: number[]
): Promise<Packet<boolean>> =>
  postRequest("/v1/Freeze/AddFreezeBulkReqs", { requestIds });

export const addFreezeRequest = (requestId: number): Promise<Packet<boolean>> =>
  postRequest("/v1/Freeze/AddFreezeReqs", { requestId });

export const editFreezeCalc = (body: {
  requestId: number;
  amount: number;
}): Promise<Packet<boolean>> => patchRequest("/v1/Freeze/EditFreezeCalc", body);

export const calculateFreezes = (): Promise<Packet<boolean>> =>
  postRequest("/v1/Freeze/calculateFreezes", {});

export const calculateReleases = (): Promise<Packet<boolean>> =>
  postRequest("/v1/Freeze/calculateReleases", {});

export const refreshFreezes = (userids: number[]): Promise<Packet<boolean>> =>
  postRequest("/v1/Freeze/refresh", { userids });

export const refreshReleases = (userids: number[]): Promise<Packet<boolean>> =>
  postRequest("/v1/Freeze/refreshReleases", { userids });
